import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

import type { PropsWithChildren } from 'react';

import LoadingCover from '@/components/Layouts/Loading';
import { isCompanyAdmin, isSupport } from '@/types/user';

const RequireCompanyAdmin = ({ children }: PropsWithChildren) => {
  const { user, isUserLoading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !isUserLoading &&
      (!user.id || (!isCompanyAdmin(user) && !isSupport(user)))
    ) {
      navigate('/m', { replace: true });
    }
  }, [isUserLoading, user, navigate]);

  if (isUserLoading) return <LoadingCover />;
  return isCompanyAdmin(user) || isSupport(user) ? children : null;
};

export default RequireCompanyAdmin;
